import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const TransactionsPage = () => {
  const navigate = useNavigate();
  const [depositHistory, setDepositHistory] = useState([]);
  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  // ==================== Fetch Transactions from API ====================
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        // Deposit History API
        const depositRes = await axios.get("https://api.earnmoney0.top/api/fund/history", {
          headers: { Authorization: `Bearer ${token}` },
        });

        // Withdraw History API
        const withdrawRes = await axios.get("https://api.earnmoney0.top/api/withdraw/history", {
          headers: { Authorization: `Bearer ${token}` },
        });

        // ✅ Filter only Approved deposits and withdrawals
        const approvedDeposits = (depositRes.data.depositRequests || []).filter(
          item => item.status === "Approved"
        );
        const approvedWithdraws = (withdrawRes.data.withdraws || []).filter(
          item => item.status === "Approved"
        );

        setDepositHistory(approvedDeposits);
        setWithdrawHistory(approvedWithdraws);
        setLoading(false);
      } catch (err) {
        console.error("Fetch Transactions Error:", err);
        setLoading(false);
      }
    };

    fetchTransactions();
  }, []);

  const renderStatus = (status) => {
    let color = "#999";

    if (status === "Approved" || status === "Complete") color = "#16a34a";
    if (status === "Rejected" || status === "Cancel") color = "#dc2626";
    if (status === "Pending") color = "#f59e0b";

    return <span style={{ color, fontWeight: 600 }}>{status}</span>;
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <span style={styles.back} onClick={() => navigate(-1)}>←</span>
        <h3>লেনদেন</h3>
      </div>

      {/* ================= DEPOSIT ================= */}
      <h4 style={styles.sectionTitle}>💰 Deposit History</h4>
      {loading ? (
        <p style={styles.empty}>Loading...</p>
      ) : depositHistory.length === 0 ? (
        <p style={styles.empty}>হিস্টোরি দেখতে আপনার Deposit (ডিপোজিট) পেজে ভিজিট করুন  নিচে দেখতে পাবেন ✅</p>
      ) : (
        depositHistory.map((item, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.row}>
              <span>Method</span>
              <b>{item.method}</b>
            </div>

            <div style={styles.row}>
              <span>Transaction ID</span>
              <b>{item.transactionId}</b>
            </div>

            <div style={styles.row}>
              <span>Date</span>
              <span>{new Date(item.createdAt || item.date).toLocaleString()}</span>
            </div>

            <div style={styles.row}>
              <span>Amount</span>
              <b>৳ {item.amount}</b>
            </div>

            <div style={styles.row}>
              <span>Status</span>
              {renderStatus(item.status)}
            </div>
          </div>
        ))
      )}

      {/* ================= WITHDRAW ================= */}
      <h4 style={styles.sectionTitle}>🏧 Withdraw History</h4>
      {loading ? (
        <p style={styles.empty}>Loading...</p>
      ) : withdrawHistory.length === 0 ? (
        <p style={styles.empty}>হিস্টোরি দেখতে আপনার Withdraw (উত্তোলন)  পেজে ভিজিট করুন  নিচে দেখতে পাবেন ✅</p>
      ) : (
        withdrawHistory.map((item, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.row}>
              <span>Method</span>
              <b>{item.method}</b>
            </div>

            <div style={styles.row}>
              <span>Date</span>
              <span>{new Date(item.createdAt || item.date).toLocaleString()}</span>
            </div>

            <div style={styles.row}>
              <span>Amount</span>
              <b>৳ {item.amount}</b>
            </div>

            <div style={styles.row}>
              <span>Status</span>
              {renderStatus(item.status)}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default TransactionsPage;

/* ---------------- STYLES ---------------- */
const styles = {
  page: {
    minHeight: "100vh",
    background: "#f2f2f2",
    padding: 12,
  },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: "15px",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  back: {
    fontSize: 22,
    cursor: "pointer",
  },
  sectionTitle: {
    marginTop: 20,
    marginBottom: 8,
    color: "#7a0f7a",
  },
  card: {
    background: "#fff",
    borderRadius: 12,
    padding: 12,
    marginBottom: 10,
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 6,
    fontSize: 14,
  },
  empty: {
    fontSize: 13,
    color: "#777",
    background: "#fff",
    padding: 12,
    borderRadius: 10,
  },
};